import { schedulerApi } from "../api/schedulerApi";
import { Options, useCollection } from "./useCollection";

export const useScheduler = <T>(path: string | string[], params?: any, options?: Options<T>) => {
    return useCollection(path, params, { ...options, api: schedulerApi });
};
